import { render } from "./BadScoreAddModal.vue?vue&type=template&id=778452ff&scoped=true"
import script from "./BadScoreAddModal.vue?vue&type=script&lang=js"
export * from "./BadScoreAddModal.vue?vue&type=script&lang=js"

import "./BadScoreAddModal.vue?vue&type=style&index=0&id=778452ff&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778452ff"]])

export default __exports__